import React from "react";
import AppInputFormik from "src/commun/composants/formulaire/formik/fields/AppInputFormik";
import { useFormikContext } from "formik";

const EmailField = () => {
  const { submitCount } = useFormikContext();

  return (
    <AppInputFormik
      name="email"
      type="text"
      iconVerif={false}
      formulaireSoumis={submitCount > 0}
      maxLength={100}
    />
  );
};

export default EmailField;
